import { buildRoute } from '@direct-frontend/modules-router';
import { type SearchParamKey } from '../hooks';

export const characteristicRoute = buildRoute('/characteristic');
export const CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB: SearchParamKey = 'active-tab' as const;
export const CHARACTERISTIC_COLORS_SEARCH_PARAM_NAME_ACTIVE_TAB_MAP = {
    COLORS: 'colors',
    ACTIVE: 'active',
    ARCHIVE: 'archive',
    GROUPS: 'groups',
} as const;
